module.exports = __webpack_public_path__ + "img/phone2.1ee7fc3d.png";